<template>
  <div v-if="$buttonAuthority(allButton, 'list')">
    <div v-if="!isReply">
      <div class="search-class">
        <el-form
          :model="searchTxt"
          :inline="true"
          size="small"
          class="serarch-form"
          label-width="100px"
          label-position="right"
        >
          <el-form-item label="平台账号">
            <el-select
              v-model="searchTxt.accountId"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in amazonAccountList"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮件主题">
            <el-input
              class="input-width"
              v-model="searchTxt.subject"
            ></el-input>
          </el-form-item>
          <el-form-item label="发件人">
            <el-input class="input-width" v-model="searchTxt.sender"></el-input>
          </el-form-item>
          <el-form-item label="发送状态">
            <el-select
              v-model="searchTxt.sendStatus"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.sendStatus"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收件人">
            <el-input
              class="input-width"
              v-model="searchTxt.recipients"
            ></el-input>
          </el-form-item>
          <el-form-item label="发送时间">
            <el-date-picker
              v-model="searchTxt.sendTimeBegin"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
            -
            <el-date-picker
              v-model="searchTxt.sendTimeEnd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
              class="input-width"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="是否AI回复">
            <el-select
              v-model="searchTxt.isAi"
              clearable
              filterable
              placeholder="请选择"
              class="input-width"
            >
              <el-option
                v-for="(val, key, i) in dropList.isAi"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()" icon="el-icon-search"
              >查找</el-button
            >
            <el-button @click="reset()" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="main-table">
        <commonTable
          ref="multipleTable"
          :loading="loading"
          :tableData="tableData"
          :tableLabel="tableLabel"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          :pageSize="pagination.pageSize"
          :currentPage="pagination.page"
          :total="pagination.total"
          :tableOption="tableOption"
          @handleButton="handleButton"
          :isHtml="true"
        >
          <template slot-scope="data">
            <el-button
              size="mini"
              v-if="$buttonAuthority(allButton, 'resend')"
              type="text"
              :disabled="data.row.isSend == 2 ? false : true"
              @click="resendClcik(data.row)"
              >重发</el-button
            >
          </template>
        </commonTable>
      </div>
    </div>
    <div v-if="isLog">
      <logLook
        :modelName="modelName"
        :logType="logType"
        :id="scope.id"
        @lookClick="isShowEdit"
      ></logLook>
    </div>

    <div v-if="isReply">
      <replay
        :scope="scope"
        @isShowEdit="isShowEdit"
        @getList="getList"
      ></replay>
    </div>
    <div v-if="isShowInfo">
      <Spread :scope="scope" @isShowEdit="isShowEdit"></Spread>
    </div>
  </div>
</template>
<script>
/**
 * 亚马逊已发送邮件列表页
 * 功能：按账号/主题/发件人/发送状态/收件人/发送时间/是否AI回复搜索，查看邮件内容详情，失败邮件可重发
 */
import { amazonSendList, editSentImport, resendEmail } from "@/api/user";
import replay from "../components/replay";
export default {
  components: { replay },
  data() {
    return {
      modelName: "account",
      logType: "ebayAccount",
      // 列表加载状态
      loading: true,
      isshowhidden: false,
      // 是否打开内容详情抽屉
      isShowInfo: false,
      // 是否首次加载（首次加载后生成列定义）
      isFirst: true,
      // 是否打开日志弹窗
      isLog: false,
      // 是否进入邮件详情页
      isReply: false,
      // 当前选中行数据
      scope: {},
      hiddenHeader: [],
      // 按钮权限列表
      allButton: [],
      // 已发送邮件列表数据
      tableData: [],
      // 表格列定义
      tableLabel: [],
      // 后端返回的列标题映射
      titleMap: [],
      dropList: {},
      renderList: {},
      dataList: [],
      // 搜索条件
      searchTxt: {
        accountId: "",
        sendStatus: "",
        subject: "",
        sender: "",
        sendTimeBegin: "",
        sendTimeEnd: "",
        recipients: "",
        isAi:""
      },
      // 分页参数
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 表格操作列定义
      tableOption: {
        label: "操作",
        width: "150",
        fixed: "right",
      },
    };
  },
  computed: {
    amazonAccountList: {
      get() {
        return this.$store.getters.dropList.amazonAccountList;
      },
    },
  },
  created() {},
  activated() {
    // 页面激活时拉取账号下拉、按钮权限并加载列表
    this.$store.dispatch("getDropListTwo", ["amazonAccountList"]);
    this.allButton = this.$getStorage(this.$route.name + "_button");
    if (this.$buttonAuthority(this.allButton, "list")) {
      Object.assign(this.pagination, this.searchTxt);
      this.getList();
      // this.tableOptionAuth();
    }
  },
  methods: {
    /** 基于后端列映射生成表格列定义（内容列可查看详情，并插入是否AI回复列） */
    getTableLabel() {
      this.tableLabel = this.$getTableLabel(this.titleMap, this.renderList);
      let param = {
        label: "内容",
        param: "context",
        align: "left",
        show: true,
        render: (h, param) => {
          let link = h(
            "el-link",
            {
              props: {
                type: "primary",
              },
              on: {
                click: () => {
                  this.isShowInfo = true;
                  this.scope = param.row;
                },
              },
            },
            "详情"
          );
          let span = h("span", this.delHtmlTag(param.row.context));

          return [link,span];
        },
      };
      this.tableLabel.splice(1, 1, param); // 去掉序号ID
      this.tableLabel.splice(0, 1); // 去掉序号ID
      this.tableLabel.splice(5, 5); // 去掉平台、id
      this.tableLabel.splice(7, 2); // 去掉编号id、客服人员
      const isAiCol = {
        label: "是否AI回复",
        param: "isAi",
        align: "center",
        show: true,
        render: (h, param) => {
          return h("span", this.$getText(param.row.isAi, this.dropList.isAi));
        },
      };
      this.tableLabel.splice(6, 0, isAiCol);
      this.tableLabel.splice(10, 1);
      this.loading = false;
    },
    /** 按 id 导入已发送邮件（回写为收件箱邮件） */
    singClick(id) {
      editSentImport({ id: id }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg);
          this.getList();
        }
      });
    },
    /** 查询已发送邮件列表 */
    getList() {
      this.loading = true;
      amazonSendList(this.pagination).then((result) => {
        if (result.code == 200) {
          this.tableData = result.data.pageInfo.records;
          this.pagination.total = result.data.pageInfo.total;
          let label = result.data.renderList;
          this.dropList = result.data.dropList;
          if (label == null) {
            this.renderList = {};
          } else {
            Object.assign(this.renderList, label);
          }
          if (this.isFirst) {
            this.titleMap = result.data.titleMap;
            this.getTableLabel();
          } else {
            this.loading = false;
          }
        }
      });
    },
    /** 关闭所有弹窗/详情页，回到列表并清空勾选 */
    isShowEdit() {
      this.isReply = false;
      this.isShowInfo = false;
      this.scope = {};
      this.$refs.multipleTable && this.$refs.multipleTable.clear();
    },
    /** 表格操作列按钮分发（重发） */
    handleButton(data) {
      var funType = data.methods;
      if (funType === "resend") {
        this.resendClcik(data.row);
      }
    },
    resendClcik(obj) {
      // 重发
      let param = {
        id: obj.id,
        content: obj.context,
        title: obj.subject,
        senderAccount: obj.sender,
        recipientAddress: obj.recipients,
        senderAddress: obj.sender,
        orderNo: obj.orderNo,
      };
      resendEmail(param).then((res) => {
        if (res.code === 200) {
          if (res.data == "发送成功") {
            this.$message.success(res.data);
          } else {
            this.$message.error(res.data);
          }
          this.getList();
        }
      });
    },
    /** 分页大小变化时重新查询 */
    handleSizeChange(value) {
      this.pagination.pageSize = value;
      this.pagination.page = 1;
      this.getList();
    },
    /** 页码变化时重新查询 */
    handleCurrentChange(value) {
      this.pagination.page = value;
      this.getList();
    },
    /** 勾选变化时记录选中的邮件数据 */
    handleSelectionChange(value) {
      this.dataList = value;
    },
    /** 按搜索条件查询已发送邮件列表 */
    search() {
      this.pagination.page = 1;
      Object.assign(this.pagination, this.searchTxt);
      this.isFirst = false;
      this.getList();
    },
    /** 清空搜索条件并重新查询 */
    reset() {
      this.pagination.page = 1;
      this.$delectObj(this.searchTxt);
      this.$delectObj(this.pagination);
      this.isFirst = false;
      this.getList();
    },
    /** 去除 HTML 标签，返回纯文本内容 */
    delHtmlTag(value) {
      return value.replace(/<[^>]+>/g, "");
    },
    /** 按按钮权限过滤表格操作列（当前未被调用） */
    tableOptionAuth() {
      let array = this.tableOption.options;
      let authOption = [];
      array.forEach((element) => {
        if (this.$buttonAuthority(this.allButton, element.methods)) {
          authOption.push(element);
        }
      });
      if (authOption.length > 0) {
        this.tableOption.options = authOption;
      } else {
        this.tableOption = {};
      }
    },
  },
  mounted() {},
  filters: {
    
  },
};
</script>
